import { render, staticRenderFns } from "./PortcallberthsForm.vue?vue&type=template&id=6b5cff52"
import script from "./PortcallberthsForm.vue?vue&type=script&lang=js"
export * from "./PortcallberthsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports